import type { ContactPropertyRelationshipRecord } from '@super/shared-types'

export function getContactDisplayName(
  contact: Pick<
    ContactPropertyRelationshipRecord,
    'firstName' | 'lastName' | 'aliases'
  >,
): string {
  if (contact.firstName && contact.lastName) {
    return `${contact.firstName} ${contact.lastName}`
  }
  if (contact.firstName) return contact.firstName
  if (contact.lastName) return contact.lastName
  if (contact.aliases && contact.aliases.length > 0) return contact.aliases[0]
  return 'Unknown Contact'
}

export function getContactSecondaryInfo(
  contact: Pick<
    ContactPropertyRelationshipRecord,
    'primaryEmail' | 'primaryPhoneNumber'
  >,
): string | undefined {
  if (contact.primaryEmail) return contact.primaryEmail
  if (contact.primaryPhoneNumber) return contact.primaryPhoneNumber
  return undefined
}

export function hasIdentifyingInfo(
  contact: Pick<
    ContactPropertyRelationshipRecord,
    'firstName' | 'lastName' | 'aliases'
  >,
): boolean {
  return !!(
    contact.firstName ||
    contact.lastName ||
    (contact.aliases && contact.aliases.length > 0)
  )
}
